export const SET_FEED_FOR_BLOCK = 'SET_FEED_FOR_BLOCK';
export const SET_BLOCK_FEED_DATA = 'SET_BLOCK_FEED_DATA';
export const APPEND_BLOCK_FEED_DATA = 'APPEND_BLOCK_FEED_DATA';
export const PREPEND_BLOCK_FEED_DATA = 'PREPEND_BLOCK_FEED_DATA';
export const FEED_DATA_FETCH_START = 'FEED_DATA_FETCH_START';
export const FEED_DATA_REFRESH_START = 'FEED_DATA_REFRESH_START';
export const FEED_DATA_LOAD_MORE_START = 'FEED_DATA_LOAD_MORE_START';
export const FEED_DATA_FETCH_SUCCESS = 'FEED_DATA_FETCH_SUCCESS';
export const FEED_DATA_REFRESH_SUCCESS = 'FEED_DATA_REFRESH_SUCCESS';
export const FEED_DATA_LOAD_MORE_SUCCESS = 'FEED_DATA_LOAD_MORE_SUCCESS';
export const FEED_DATA_FETCH_FAILED = 'FEED_DATA_FETCH_FAILED';
